/** Shared identifier identity: custom-databases.decisions.md, “Identifier rule”. */
export function fold(name: string): string {
  return name.normalize('NFC').toUpperCase().toLowerCase()
}

export function validName(name: string): boolean {
  return name === name.normalize('NFC') && name.trim().length > 0 &&
    !/[\p{Cc}\p{Cf}\p{Cs}\p{Zl}\p{Zp}\p{Default_Ignorable_Code_Point}]/u.test(name)
}

export function quoteIdent(name: string): string {
  return `"${name.replaceAll('"', '""')}"`
}

export function quoteLiteral(value: string): string {
  return `'${value.replaceAll("'", "''")}'`
}
